import { useState, useEffect } from "react";
import {NavLink, useLocation} from "react-router-dom";
import axios from "axios";
import MenuNavbar from '../../../MenuNavbar';
import Floaticons from '../../../Floaticons';
import baseUrl from "../../../../utils/Constants";
import { Breadcrumbs } from "@material-ui/core";
import CRRAccordian from "./C-Suite-CyberAdvisory/CSuiteAccordian";
import SSAccordian from "./SecurityStrategy-Organization/SSAccordian";
import "../TabContentStyles.css";

function CyberStrategyTab() {    
    const [displaySkill, setDisplaySkill] = useState('digital');    
    const [cyberOfferingsCourses, setCyberOfferingsCourses] = useState([]);
    const [filteredCyberOfferingsCourses, setFilteredCyberOfferingsCourses] = useState([]);

    const location = useLocation();
    const offeringName = location.state?.offeringName;

    const getCyberOfferingCourses = async () => {
        try {
            const res = await axios.get(`${baseUrl}/security-offerings`, {
                params: {
                    security_offering: offeringName
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem("token")
                }
            });

            if (res.data?.result?.length > 0) {   
                const response = res.data.result;             
                setCyberOfferingsCourses(response);                
                const filteredCourses = response.filter(course => {
                    console.log("course.mode:", course.mode.toLowerCase(), "displaySkill:", displaySkill.toLowerCase());
                    console.log(course.mode.toLowerCase() === displaySkill.toLowerCase());
                    return course.mode.toLowerCase() === displaySkill.toLowerCase(); 
                });
                console.log("filteredCourses--", filteredCourses);                
                setFilteredCyberOfferingsCourses(filteredCourses);                
            } else {
                setCyberOfferingsCourses([]); 
            }
        } catch (err) {
            console.error("Error fetching cyber offerings courses:", err);
            setCyberOfferingsCourses([]);
        }
    };    

    useEffect(() => {
        getCyberOfferingCourses();        
    }, [])        

    useEffect(() => {                    
        const filteredCourses = cyberOfferingsCourses.filter(course => {            
            return course.mode.toLowerCase() === displaySkill.toLowerCase(); 
        });
        setFilteredCyberOfferingsCourses(filteredCourses);                
    }, [displaySkill])    
    
    return (
        <>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <MenuNavbar />
            </div>
            <Floaticons />
            <div className="TabPanelWrapper">
                <div className="SSA-breadcrumbLinks">
                    <Breadcrumbs separator="/" aria-label="breadcrumb">
                        <NavLink className="menu_title" to="/SecuritySpecializationAcademyNew">
                            <img src="images/SSA/Backbutton.png" class="breadcrumbBack" />
                            {offeringName}
                        </NavLink>
                        {displaySkill === "digital" && (
                            <a className="menu_title">Digital</a>
                        )}
                        {displaySkill === "Virtual/Classroom" && (
                            <a className="menu_title">Virtual or Classroom</a>                            
                        )}
                        {displaySkill === "blended" && (
                            <a className="menu_title">Blended</a>                            
                        )}
                    </Breadcrumbs>
                </div>
                <div className="tabNavMenu">
                    <a
                        className={displaySkill === "digital" ? "subtabActive" : "subtabInactive"}
                        onClick={() => {setDisplaySkill("digital");}}                        
                    >
                        <span>Digital</span>
                    </a>
                    <a
                        className={displaySkill === "Virtual/Classroom" ? "subtabActive" : "subtabInactive"}
                        onClick={() => {setDisplaySkill("Virtual/Classroom");}}                        
                    >
                        <span>Virtual / Classroom</span>
                    </a>
                    <a
                        className={
                            displaySkill === "blended" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {setDisplaySkill("blended");}}                        
                    >
                        <span>Blended</span>
                    </a>
                </div>
                {filteredCyberOfferingsCourses.length > 0 ? <div className="TabPanel-Wrap">                    
                    <CRRAccordian crrAc = {filteredCyberOfferingsCourses}/>                    
                </div> : <div style={{"margin-top": "28px","font-size": "15px"}}>Courses not found</div>}
            </div>
        </>
    );
}

export default CyberStrategyTab;